import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDebouncedCallback } from "use-lodash-debounce";
import addedFilter from "../redux/filter/action";
import Navbar from "./Navbar";
import SearchBox from "./SearchBox";
import SingleCard from "./SingleCard";

const CardContainer = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const dispatch = useDispatch("");
    const allBlogs = useSelector((state) => state.allBlogs);
    const filter = useSelector((state) => state.filter);
    const { status } = filter;

    // dispatch handler for getting all blogs
    const getAllBlogs = (term) => {
        dispatch(addedFilter(term));
    };

    const debounceSetSearchTerm = useDebouncedCallback(setSearchTerm, 800);

    return (
        <div>
            <Navbar />
            <SearchBox
                setSearchTerm={debounceSetSearchTerm}
                searchTerm={searchTerm}
            />
            {/* Card Container */}
            <section className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8">
                <div className="absolute inset-0">
                    <div className="bg-white h-1/3 sm:h-2/3"></div>
                </div>
                <div className="relative max-w-7xl mx-auto">
                    <div className="text-center">
                        <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
                            ALL BLOGS ARE HERE
                        </h2>
                        <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
                            Lorem ipsum dolor sit amet consectetur, adipisicing
                            elit. Ipsa libero labore natus atque, ducimus sed.
                        </p>
                        <button
                            className="bg-black text-white px-4 py-2 mt-2 rounded"
                            onClick={() => getAllBlogs("")}
                        >
                            Get All Blogs
                        </button>
                    </div>

                    {/* <!-- card grid  --> */}
                    <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
                        {allBlogs
                            ?.filter((blog) => {
                                if (status === "") {
                                    if (searchTerm !== "") {
                                        return blog.title
                                            .toLowerCase()
                                            .includes(searchTerm.toLowerCase());
                                    }
                                    return blog;
                                } else if (
                                    blog.category.includes(status) ||
                                    blog.author.includes(status)
                                ) {
                                    return blog;
                                }
                            })
                            .map((blog) => (
                                <SingleCard {...{ blog }} key={blog.id} />
                            ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CardContainer;
